import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';

import { Modal } from '../../../../../components/Modal';
import { Route } from '../../../../../domain/route/Route';
import InputText from '../../../../../react-components/InputText';
import { Text } from '../../../../../react-components/Text';
import { usePermissions } from '../../../hooks/usePermissions';
import { PRIVATE_COMPONENT_ID } from '../../../PrivateComponent';
import { useUpdateRoute } from '../../hooks/useUpdateRoute';

type RouteLabelProps = {
  selectedRoute: Route;
};

export const RouteLabel = ({ selectedRoute }: RouteLabelProps) => {
  const { canManageStops: canUpdateLabel } = usePermissions();
  const [label, setLabel] = useState<string | undefined>(selectedRoute.plan_label);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const {
    // error,
    success,
    isLoading,
    run: updateRoute,
  } = useUpdateRoute();

  useEffect(() => {
    if (success) {
      setDialogOpen(false);
      setLabel(undefined);
    }
  }, [success]);

  return (
    <>
      {selectedRoute.plan_label ? (
        <Text
          onClick={() => {
            if (canUpdateLabel) {
              setDialogOpen(true);
            }
          }}
          variant="h6"
        >
          {selectedRoute.plan_label}
        </Text>
      ) : (
        <Text
          onClick={() => {
            if (canUpdateLabel) {
              setDialogOpen(true);
            }
          }}
          variant="h6"
          style={{ color: RoutalPalette.secondary00 }}
          intlId="drivers.route_header.no_label"
        />
      )}

      <Modal
        open={dialogOpen}
        title={{
          intlId: `drivers.route_header.edit_label_dialog.title`,
        }}
        portalElementId={PRIVATE_COMPONENT_ID}
        isLoading={isLoading}
        buttons={[
          {
            intlId: `accept`,
            disabled: (label ?? ``) === ``,
            onClick: () => {
              console.info(`Update Route Label: `, label);
              updateRoute({
                route: selectedRoute,
                label: label ?? ``,
              });
            },
          },
          {
            intlId: `cancel`,
            onClick: () => {
              setDialogOpen(false);
            },

            variant: `text`,
            style: {
              border: `none`,
            },
          },
        ]}
        children={
          <>
            <VSpacer medium />
            <InputText
              placeholderIntlId="drivers.route_header.no_label"
              fieldValue={label || ``}
              onChange={(value) => setLabel(value)}
              variant="outlined"
              inputContainerStyles={{ width: `100%`, height: `40px` }}
              inputStyles={{
                width: `100%`,
                borderColor: RoutalPalette.grey7,
                color: (label ?? ``) !== `` ? RoutalPalette.text : undefined,
              }}
            />
          </>
        }
      />
    </>
  );
};
